// @ts-nocheck
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { flow, Instance, types } from 'mobx-state-tree';
import { DutyExchangeItem } from './models/DutyExchangeItem';

export const DutyExchangeItemSearchCriteria = types.model({
  pharmacyId: types.maybeNull(types.number),
  secretariatId: types.maybeNull(types.number),
  startStudyDate: types.maybeNull(types.Date),
  //onlyFutureDutyExchange: types.maybeNull(types.boolean),
  //year: types.maybe(types.number),
  //fromYear: types.maybe(types.number),
});

export const DutyExchangeItemStore = types
  .compose(
    getBaseStore<Instance<typeof DutyExchangeItem>, Instance<typeof DutyExchangeItem>>(
      DutyExchangeItem,
      'dutyExchangeItemId',
      'dutyExchangeItem',
    ),
    types.model('DutyExchangeItemStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const search = flow(function*(criteria: Instance<typeof DutyExchangeItemSearchCriteria>) {
      const result = yield apiFetcher.get('dutyExchangeItem', {
        params: criteria,
      });
      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyExchangeItemId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyExchangeItemId) >= 0);
    });

    return {
      search,
    };
  });
